import { ApiService } from '@libs-uuif/shared/api-service';
import {
  localStorageKeeperService,
  sessionStorageKeeperService,
} from '../auth-service';
import { nsmApiService } from '@/shared/api-service/nsm-api-service';
import { ccApiService } from '@/shared/api-service/cc-api-service';
import { wcmApiService } from '@/shared/api-service/wcm-api-service';
import axios from 'axios';
import { confirmService } from '@sonicwall/unified-ui-framework/src/shared/confirm-service';
import { envCongif } from '../env.config';

const cscBasePath: string = envCongif.api_url || '';
// keep this values static as of now as there is no other tenant authorized for the provided CSC user
const splitSsoString = 'sso/';
const splitCcTenantIdString = 'cctenantid=';
const splitNsmTenantNameString = 'tenantname';
const splitNsmTenantSerialString = 'tenantserial';
const ccAppName = 'CCLIENT';

// currently this values are static as we don't get the values from the CSC local storage
// tslint:disable-next-line:max-line-length
const ccReturnUrl =
  'aHR0cHM6Ly9jbG91ZC5zb25pY3dhbGwuY29tL3dvcmtzcGFjZS9tL2ZlYXR1cmUvc3BvZy1ob21lcGFnZT90ZW5hbnQ9MjA2MzQ1NSZ0ZW5hbnROYW1lPXNvbmljd2FsbCBQcm9kdWN0cw==';
const ccSpogSrc =
  'aHR0cHM6Ly9jbG91ZC5zb25pY3dhbGwuY29tL3dvcmtzcGFjZS9tL2ZlYXR1cmUvc3BvZy1ob21lcGFnZT90ZW5hbnQ9MjA2MzQ1NSZlbWJlZD1ZRVM=';

export class CSCApiService {
  cscApiWrapper = new ApiService(cscBasePath);

  /**
   * @desc Get the logged in user details from the local storage
   */
  fetchCscUserData() {
    return localStorageKeeperService.retrieveJSON('currentUser') || {};
  }

  /**
   * @desc Get the authorization token
   */
  getDefaultHeaders() {
    return {
      Authorization: this.fetchCscUserData().token,
    };
  }

  /**
   * @desc Get the available tenants to the logged in user
   */
  getCloudTenants() {
    return this.cscApiWrapper
      .get<any>(`/hgms/get-cloud-tenants?username=${this.fetchCscUserData().userId}&bisfromCSC2=true`, {
        headers: this.getDefaultHeaders(),
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.error('Cloud Tenants API error', error);
        this.handleError(error);
      });
  }

  /**
   * @desc Get the redirection URL of the product
   * @param params parameters that is to be passed to API
   */
  redirectToApplication(params: any) {
    return axios.get<any>(`${cscBasePath}/redirect-to-application`, {
      params,
    });
  }

  /**
   * @desc Fetch the SSO token based on the product
   * @param product available products to the tenant
   * @param tenant selected tenant id
   */
  async fetchSsoTokens(
    product: string,
    tenant: string,
    setFlag: any,
    navigateUrl = '',
    setCcBaseUrl: any = null,
    nsmBaseUrl = '',
    wcmBaseUrl = '',
    arrTenantOptions: any = [],
  ) {
    const currentUserData = this.fetchCscUserData();
    switch (product) {
      case 'NGMGMT':
        if (navigateUrl) {
          const tenantSerial = new URLSearchParams(navigateUrl).get(splitNsmTenantSerialString) || '';
          const tenantName = new URLSearchParams(navigateUrl).get(splitNsmTenantNameString) || '';
          if (tenantName !== '' && tenantSerial !== '') {
            let accessCode = '';
            if (arrTenantOptions && arrTenantOptions.filter((item : any) => item.tileType === 'ISNSMSAFEENABLED' && item.Value === 'YES').length > 0) {
              await cscApiService
            .generateCscCode({ tenantId: tenant, tileName: 'ISNSMSAFEENABLED' })
            .then((response) => {
              if (
                response &&
                response.content &&
                response.content.accessCode
              ) {
                accessCode = response.content.accessCode;
              } else {
                throw new Error();
              }
            });
            }
            let requestObj = {};
            if (accessCode) {
              requestObj = {
                code : accessCode,
                devtest:true,
                tenantname: tenantName,
                tenantserial: tenantSerial,
              };
            } else {
              requestObj = {
                authtoken: currentUserData.token,
                tenantname: tenantName,
                tenantserial: tenantSerial,
              };
            }
            await nsmApiService
              .getSsoToken(nsmBaseUrl, requestObj)
              .then((res: any) => {
                if (!res.status.success) {
                  throw new Error(res.status.info.message);
                }
                sessionStorageKeeperService.save(
                  'nsmToken',
                  `Bearer ${res?.status?.info[0]?.message}`,
                );
              })
              .catch((error: any) => {
                console.error('NSM SSO API error', error);
              });
          } else {
            console.error('Failed to retrieve NSM tenantName and tenantSerial');
          }
        }
        break;
      case 'Capture Client':
        await cscApiService
          .redirectToApplication({
            tenant,
            username: currentUserData.userId,
            sessionID: currentUserData.sessionId,
            appName: ccAppName,
            returnUrl: ccReturnUrl,
            spogSrc: ccSpogSrc,
            embedResponse: 'YES',
          })
          .then(async (response: any) => {
            const tokenData: string = response?.data?.content?.token || response?.content?.token || null;
            const baseUrl =
              tokenData?.substring(0, tokenData.indexOf('/sso')) || '';
            setCcBaseUrl(baseUrl);
            if (tokenData) {
              const ssoToken = tokenData.substring(
                tokenData.indexOf(splitSsoString) + splitSsoString.length,
                tokenData.indexOf('/?'),
              );
              const tenantId = tokenData.substring(
                tokenData.indexOf(splitCcTenantIdString) +
                  splitCcTenantIdString.length,
                tokenData.indexOf('&cctenantname'),
              );
              if (ssoToken !== '' && tenantId !== '') {
                await ccApiService
                  .getSsoToken(baseUrl, {
                    ssoToken,
                    tenantId,
                  })
                  .then((res: any) => {
                    sessionStorageKeeperService.save('ccToken', res.token);
                  })
                  .catch((error: any) => {
                    console.error('CC SSO API error', error);
                  });
              } else {
                throw new Error(
                  'Failed to retrieve CC SSO Token and tenant id',
                );
              }
            }
          })
          .catch((error) => {
            console.error('CC redirect to application error', error);
          });
        break;
      case 'Wireless':
        try {
          const baseUrl = wcmBaseUrl?.substring(0, wcmBaseUrl.indexOf('/sso')) || '';
          let accessCode = '';
          await cscApiService
            .generateCscCode({ tenantId: tenant, tileName: 'ISWNMSAFEENABLED' })
            .then((response) => {
              if (
                response &&
                response.content &&
                response.content.accessCode
              ) {
                accessCode = response.content.accessCode;
              } else {
                throw new Error();
              }
            })
            .catch((error) => {
              console.error('CSC Code generation API error', error);
              this.handleError(error);
            });
          accessCode && await wcmApiService
            .getAuthStorage(baseUrl, {
              headers: {
                'id-code': accessCode,
                'msw-user-id': currentUserData.userId || '',
                'msw-tenant-id': tenant,
                msw_user_id: currentUserData.userId || '',
                msw_tenant_id: tenant,
              },
            })
            .then((response) => {
              sessionStorageKeeperService.saveJSON('wcmSession', {
                ssoKeys: response,
              });
            })
            .catch((error) => {
              console.error('Wireless Auth API Error', error);
            });
          const wcmSession = sessionStorageKeeperService.retrieveJSON('wcmSession');
          if (wcmSession && wcmSession.ssoKeys && wcmSession.ssoKeys.tenants && wcmSession.ssoKeys.tenants.length > 0) {
            const wnmTenant = wcmSession.ssoKeys.tenants.find((tenantName: any) => {
              return tenantName.msw_tenant_id === tenant;
            });
            wnmTenant && await wcmApiService
            .activateTenant(`/tenants/${wnmTenant.tenant_id}` , {})
            .then()
            .catch((error: any) => {
              console.error('Wireless Tenant API Error', error);
            });
            setFlag('Wireless-tenantActivated', true);
          } else {
            setFlag('Wireless-tenantActivated', true);
          }
        } catch (error) {
          console.error('Wireless SSO Fetching Error', error);
          setFlag('Wireless-tenantActivated', true);
        }
        break;
      default:
        return null;
    }
    setFlag(product, true);
  }

  /**
   * @desc Get the layout of the dashboard
   * @param params tenant data to pass to API
   */
  getDashboardLayout(params: any) {
    return this.cscApiWrapper.get<any>(
      '/hgms/get-unifiedinsights-widget-pref',
      { params, headers: this.getDefaultHeaders() },
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error('Dashboard layout API error', error);
      this.handleError(error);
    });
  }

  /**
   * @desc Get the user of that particular tenant
   * @param params tenant data to pass to API
   */
  getUserForTenant(tenantId: string = '') {
    let url = '/hgms/get-unifiedinsights-dashboard';
    if (tenantId && tenantId !== '') {
      url = `/hgms/get-unifiedinsights-dashboard?tenantId=${tenantId}`;
    }
    return this.cscApiWrapper.get<any>(
      url,
      { headers: this.getDefaultHeaders() },
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error('Dashboard layout API error', error);
      this.handleError(error);
    });
  }

  /**
   * @desc Save the layout of the dashboard
   * @param data widget data to pass to API
   */
  saveDashboardLayout(mode:string, data: any) {
    return this.cscApiWrapper.put<any>(
      `/hgms/save-unifiedinsights-widget-pref?mode=${mode}`,
      data,
      { headers: this.getDefaultHeaders() },
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error('Dashboard layout fetch API error', error);
      this.handleError(error);
    });
  }

  deleteDashboardLayout(data : any) {
    return this.cscApiWrapper.put<any>(
      '/hgms/save-unifiedinsights-widget-pref?mode=CLEAR', data ,
      { headers: this.getDefaultHeaders() },
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error('Dashboard layout fetch API error', error);
      this.handleError(error);
    });
  }

  /**
   * @desc to fetch uniquely generated CSC code
   * @param data required CSC data as payload
   */
  generateCscCode(data: any) {
    return this.cscApiWrapper.post<any>('/generate-cscaccesscode', data, {
      headers: this.getDefaultHeaders(),
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error('CSC Code generation API error', error);
      this.handleError(error);
    });
  }

  /**
   * @desc to handle authorization error
   * @param error response error
   */
  handleError(error: any) {
    if (error && error.response && error.response.status === 401) {
      return confirmService.confirm({
        message: 'Your session has expired. Please log-in again to continue.',
        title: 'Session Expired',
        status: 'informational',
        buttons: [
          {
            key: 'ok',
            name: 'OK',
            isDefault: true,
          },
        ],
      })
      .then(() => {
        localStorageKeeperService.clean();
        sessionStorageKeeperService.clean();
        window.location.replace('https://cloud.sonicwall.com');
      });
    }
  }

  validateToken() {
    return new ApiService('https://wsdl.mysonicwall.com/api').get<any>('/DeriveUsernamefromtoken', {
    // return new ApiService('https://10.194.31.54/api').get<any>('/DeriveUsernamefromtoken', { // for dev
    // return new ApiService('https://10.5.50.126/api').get<any>('/DeriveUsernamefromtoken', { // for qa
      headers: {
        Authorization: `Bearer ${this.fetchCscUserData().token}`,
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error('CSC Token Expiration Error', error);
      this.handleError(error);
    });
  }
}

export const cscApiService = new CSCApiService();
